
export function　calcWorkingHoursWithinLaw( timeCounts) {
    if (
      "diffrence_monthly_predefined_and_work" in timeCounts &&
      timeCounts.diffrence_monthly_predefined_and_work < 0
    ) {
      return (
        -1 * timeCounts.diffrence_monthly_predefined_and_work -
        timeCounts.overtime_by_law
      );
    } else {
      return 0;
    }
  }